module.exports = __webpack_public_path__ + "static/media/clarice.be5ef0bc.png";